// extracted by mini-css-extract-plugin
export default {"TaskListMenuTriggerButton":"TaskListMenu-module__TaskListMenuTriggerButton--GR2W2"};